import * as TYPES from './types'

/**
 * Default Auth State
 */
export const defaultState: TYPES.AuthState = {
  httpInProgress: false,
  httpUpdateInProgress: false,
  httpError: '',
  authToken: '',
  gnUser: {
    userID: '',
    country: '',
    userName: '',
    userEmail: '',
    userRole: 'gn_user',
    userPictureUrl: '',
    sinceTimestamp: 0,
    settings: {
      isColaborationEmailSubscribed: true,
    }
  },
  systemSettings: {
    actualUEPluginVersion: '',
    latestUEPluginVersionDownloadURL: '',
    publicBillingTiers: []
  }
}

// define initial state object
const initialState: TYPES.AuthState = {
  httpInProgress: defaultState.httpInProgress,
  httpUpdateInProgress: defaultState.httpUpdateInProgress,
  httpError: defaultState.httpError,
  authToken: sessionStorage.getItem('authToken') || defaultState.authToken,
  gnUser:{
    userID: sessionStorage.getItem('userID') || defaultState.gnUser.userID,
    country: sessionStorage.getItem('userCountry') || defaultState.gnUser.country,
    userName: sessionStorage.getItem('userName') || defaultState.gnUser.userName,
    userEmail: sessionStorage.getItem('userEmail') || defaultState.gnUser.userEmail,
    userRole: sessionStorage.getItem('userRole') || defaultState.gnUser.userRole,
    userPictureUrl: sessionStorage.getItem('userPictureUrl') || defaultState.gnUser.userPictureUrl,
    sinceTimestamp: parseInt(sessionStorage.getItem('userSinceTimestamp') || '0') || defaultState.gnUser.sinceTimestamp,
    settings: {
      isColaborationEmailSubscribed: sessionStorage.getItem('isColaborationEmailSubscribed') === 'true' || defaultState.gnUser.settings.isColaborationEmailSubscribed,
    }
  },
  systemSettings: {
    actualUEPluginVersion: sessionStorage.getItem('actualUEPluginVersion') || defaultState.systemSettings.actualUEPluginVersion,
    latestUEPluginVersionDownloadURL: sessionStorage.getItem('latestUEPluginVersionDownloadURL') || defaultState.systemSettings.latestUEPluginVersionDownloadURL,
    publicBillingTiers: JSON.parse(sessionStorage.getItem('publicBillingTiers') || '[]') || defaultState.systemSettings.publicBillingTiers,
  }
}

// define auth reducer
export function authReducer (
  state = initialState,
  action: TYPES.AuthActionTypes
): TYPES.AuthState {
  switch (action.type) {
    case TYPES.AUTH_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: true, httpUpdateInProgress: false, httpError: '' }
      }
    }
    case TYPES.AUTH_UPDATE_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: false, httpUpdateInProgress: true, httpError: '' }
      }
    }
    case TYPES.AUTH_UPDATE_TOKEN: {
      return {
        ...state,
        ...{ authToken: action.authToken },
      }
    }
    case TYPES.AUTH_ERROR: {
      return {
        ...state,
        ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: action.error }
      }
    }
    case TYPES.AUTH_CLEAR_ERROR: {
      return {
        ...state,
        ...{ httpError: '' }
      }
    }
    case TYPES.AUTH_LOGIN: {
      return {
        ...state,
        ...action.payload,
        ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: '' }
      }
    }
    case TYPES.AUTH_LOGOUT: {
      return {
        ...state,
        ...defaultState
      }
    }
    case TYPES.AUTH_UPDATE_GNUSER: {
      return {
        ...state,
        gnUser: {
          ...state.gnUser,
          ...action.payload.gnUser
        }
      }
    }
    case TYPES.AUTH_UPDATE_BILLING_TIERS: {
      return {
        ...state,
        systemSettings: {
          ...state.systemSettings,
          publicBillingTiers: action.publicBillingTiers
        }
      }
    }
    default:
      return state
  }
}
